// extracted by mini-css-extract-plugin
export default {"tablecell_div_style":"VesselStyle_tablecell_div_style__+yiM6","select_style":"VesselStyle_select_style__5ITWd","manualVessel":"VesselStyle_manualVessel__XpuwV"};